import { BetBuilderLeg } from '../types/BetBuilderPreview';

export const getEventIdsFromQuery = (value: string | (string | null)[], toggleInterlock: boolean): number[] => {
    if (!value) {
        return [];
    }

    if (Array.isArray(value)) {
        if (!value.length) {
            return [];
        }

        if (toggleInterlock) {
            return value.map((eventId) => Number(eventId));
        }

        return [Number(value[0])];
    } else {
        return [Number(value)];
    }
};

export const arrayEquals = <T>(a: T[], b: T[]): boolean => {
    return a.length === b.length
        && a.every((val, index) => val === b[index]);
};

export const isElementInViewport = (
    el: HTMLElement,
    completely = false,
    containerRect = new DOMRect(0, 0, window.innerWidth || document.documentElement.clientWidth, window.innerHeight || document.documentElement.clientHeight),
) => {
    const rect = el.getBoundingClientRect();
    const positionToCompareWithLeft = completely ? rect.left : rect.right;
    const positionToCompareWithRight = completely ? rect.right : rect.left;
    const positionToCompareWithTop = completely ? rect.top : rect.bottom;
    const positionToCompareWithBottom = completely ? rect.bottom : rect.top;
    const { top, left, right, bottom } = containerRect;

    return positionToCompareWithTop > top
        && positionToCompareWithLeft > left
        && positionToCompareWithRight < right
        && positionToCompareWithBottom < bottom;
};

export const getSortedSummaryLegs = (legs: BetBuilderLeg[], selectedOddUuids: Set<string>): BetBuilderLeg[] => {
    const legsMap = legs.reduce((map, leg) => {
        map.set(leg.uuid, leg);

        return map;
    }, new Map<string, BetBuilderLeg>());
    const selectedOddUuidsArray = Array.from(selectedOddUuids);

    // Since selectedOddUuids are stored in order of selection,
    // we need to reverse the order to show the last added legs on top of the list
    selectedOddUuidsArray.reverse();

    // Since selectedOddUuids are stored in order of selection,
    // they are used to sort the summary legs by mapping them against one another via the uuid
    return selectedOddUuidsArray.filter((uuid) => legsMap.has(uuid)).map((uuid) => legsMap.get(uuid)!);
};
